module.exports = __webpack_public_path__ + "media/images/new-feature-icon-a29a0619.png";